import {Component} from '@angular/core';
import {LayoutService} from '../../layout.service';

@Component({
    selector: 'app-sa-collapse-menu',
    templateUrl: './collapse-menu.component.html'
})
export class CollapseMenuComponent {

    constructor(
        private layoutService: LayoutService
    ) {
    }

    onToggle() {
        this.layoutService.onCollapseMenu()
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/collapse-menu/collapse-menu.component.ts